import React from 'react'
import { useSelector } from 'react-redux'

const InfoOptions = () => {
  const state = useSelector((state) => state.reducer);

  return (
    <div className='content-text'>
        All additional features for the building’s frame and materials are shown here. Both visual and non-visual elements including snow/wind ratings, anchors, installation surfaces, overhang, colored screws, and many more as offered by the provider will be available. 
        <br /><br />
        <span>Wind & Snow Rating – </span>Should be selected based on the permit requirement of your region. Check here to find your region’s specific ratings - 
        <br />
        <a href='https://hazards.atcouncil.org/'>https://hazards.atcouncil.org/</a> 
        <br /><br />
        <span>Other Components – </span>If you wish to add any other components that aren’t listed in the configuration panel, you can add it here with name and quantity. 
        {
          !state.const_var.loginSession &&
          <>
            <br /><br />
            <span className='italic'>PLEASE NOTE THAT THE PRICE FOR ANY ADDITIONAL COMPONENT WILL BE ADDED & CONFIRMED BY OUR SALES PROFESSIONALS AT THE TIME OF QUOTE REVIEW.</span>
          </>
        }
        <br /><br />
        Installation Surfaces are shown for representation purposes only and not included in building price. 
        <br /><br />
        Provide your jobsite information and any special notes to help with the speedy installation of your building here.
    </div>
  )
}

export default InfoOptions